import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from "./Variables.js";

export default function MatchHomePage() {

  const jsonUrl = variables.basename_url + "updates/index/Athlethixnet_HomeEn_Matches.json";
  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();

  const [Match_HomePage, setMatch_HomePage] = React.useState([]);
  const [Match_HomePageWithResult, setMatch_HomePageWithResult] = React.useState([]);

  async function refda() {
    Get_Data_FMostViewed();
  };

async function Get_Data_FMostViewed() {

  setNisLoading(true);

  axios.get(jsonUrl)
    .then(function (response) {

      const data = response.data || [];
      const firstSix = data.slice(0, 6);
      const matches = firstSix.map(item => {

  const dateTime = item.SM_game_date_time || "";
  const [datePart, timePart] = dateTime.split("T");

  return {
    id: item.SM_id,
    SLT_name_en: item.SLT_name_en?.trim() || "",
    SLT_Logo: item.SLT_Logo,
    Day: datePart || "",
    Time1: timePart ? timePart.slice(0, 5) : "",
    Team1: item.Team1,
    Team2: item.Team2,
    ST_logo: item.ST_logo,
    ST_logo1: item.ST_logo1,
    SM_score1: item.SM_score1,
    SM_score2: item.SM_score2,
  };
});

setMatch_HomePageWithResult(matches);
      setNisLoading(false);

    })
    .catch(function (error) {
      console.error("Error fetching data:", error);
      setNisLoading(false);
    });
}

  useEffect(() => {
    setNisLoading(true);
    refda();
  }, []);

  return (
    <>
      <div className="upcoming-matches-post mt-35 most-view-box mt-0 border ">
        <div className="section-title d-flex justify-content-between align-items-center">
          <h3 className="title">Latest Matches</h3>
          <a href="FootballMatches"> SEE ALL</a>
        </div>
        <div className="upcoming-matches-post-items">
          <div className="container">
            {Match_HomePageWithResult.map(da => (
              <div key={da.id} className="match-card d-flex align-items-center justify-content-between p-3 border-0 rounded mb-3">

                {/* Team 1 */}
                <div className="team d-flex align-items-center justify-content-start flex-shrink-0" style={{ width: '140px' }}>
                  <img src={variables.MatchesImg + da.ST_logo} className="team-logo rounded-circle me-2" alt={da.Team1} />
                  <span className="team-name text-truncate" style={{ width: '100px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {da.Team1}
                  </span>
                </div>

                {/* Date or Score */}
                <div className="match-info text-center flex-shrink-0" style={{ width: '100px' }}>
                  {da.SM_score1 === '' || da.SM_score1 === '-1' || da.SM_score1 === '-' ? (
                    <>
                      <span className="match-time d-block" style={{ fontSize: '13px' }}>{da.Time1}</span>
                      <span className="match-date d-block" style={{ fontSize: '12px' }}>{da.Day}</span>
                    </>
                  ) : (
                    <>
                      <span className="match-score d-block" style={{ fontSize: '14px' }}>
                        {da.SM_score1} <span className="score-separator">-</span> {da.SM_score2}
                      </span>
                      <span className="match-date d-block" style={{ fontSize: '11px' }}>{da.Day}</span>
                      <span className="match-time d-block" style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600 }}>
                        {da.Time1}
                      </span>
                    </>
                  )}
                </div>

                {/* Team 2 */}
                <div className="team d-flex align-items-center justify-content-end flex-shrink-0" style={{ width: '140px' }}>
                  <img src={variables.MatchesImg + da.ST_logo1} className="team-logo rounded-circle ms-2" alt={da.Team2} />

                  <span className="team-name text-truncate" style={{ width: '100px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {da.Team2}
                  </span>
                </div>

              </div>
            ))}
          </div>
        </div>



      </div>
    </>
  );
}
